import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  canonical,
  ogType = 'website',
  ogImage = '/logo.jpg',
  twitterCard = 'summary_large_image',
  keywords,
  noindex = false,
  children
}) => {
  const siteName = 'Safir Foundation';
  const defaultDescription = 'Safir Foundation supports education in Afghanistan through scholarships, courses, and learning opportunities.';
  const defaultImage = 'https://safir-foundation.org/logo.jpg';
  
  const pageTitle = title ? `${title} | ${siteName}` : siteName;
  const pageDescription = description || defaultDescription;
  const pageUrl = canonical ? `https://safir-foundation.org${canonical}` : 'https://safir-foundation.org';
  const pageImage = ogImage?.startsWith('http') ? ogImage : `https://safir-foundation.org${ogImage || '/logo.jpg'}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={pageUrl} />
      
      {/* Robots */}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      
      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
      
      {/* Additional SEO */}
      <meta name="author" content="Safir Elite" />
      <meta property="og:locale:alternate" content="fa_AF" />
      <meta name="twitter:site" content="@safirfoundation" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      
      {children}
    </Helmet>
  );
};

export default SEO;
